import './less/TwoFactorVerification.less';
import './less/TwoFactorIcons.less';

import clsx from 'clsx';
import React, { useState } from 'react';
import { Button } from '../button/Button';
import { TwoFactorSuccessIcon } from '../../icons/TwoFactorVerSuccessIcon';
import { get2FAContext, runContextCallback } from './index';
import handleError2FA from './util/handleError2FA';
import { isImplicitReason } from './views/reason';
import { useInterval } from '../../common/hooks/useInterval';
import i18n from '../../common/i18n';

const TwoFactorVerSuccess = ({ token, onClose, portal }) => {
    const [blocking, setBlocking] = useState();
    const reason = get2FAContext().reason;

    const onClosePopUp = () => {
        setBlocking(true);
        onClose();
    };
    const onCloseLogin = () => {
        setBlocking(true);
        runContextCallback(token).catch(handleError2FA({ setBlocking }));
    };

    return (
        <div
            className={clsx('two-factor-ver-box', {
                'two-factor-ver-box-padding': portal
            })}
        >
            <TwoFactorSuccessIcon />
            <h1 className="two-factor-ver-title">{i18n('nui.two.fa.success.verification.title')}</h1>
            {isImplicitReason(reason) ? (
                <>
                    <h3 className="two-factor-ver-description">
                        {i18n('nui.two.fa.success.verification.description')}
                    </h3>
                    <Button
                        primary
                        large
                        className={'two-factor-ver-submit nui-button-max-300'}
                        type="button"
                        disabled={blocking}
                        onClick={onClosePopUp}
                        label={i18n('nui.button.close')}
                    />
                </>
            ) : (
                <>
                    <h3 className="two-factor-ver-description">
                        {i18n('nui.two.fa.success.verification.login.description')}
                    </h3>
                    <LoginButton blocking={blocking} onClose={onCloseLogin} />
                </>
            )}
        </div>
    );
};

function LoginButton({ blocking, onClose }) {
    let [elapsed, setElapsed] = useState(1);
    useInterval(
        () => {
            setElapsed(elapsed + 1);
            if (elapsed + 1 >= 5) {
                onClose();
            }
        },
        blocking ? null : 1000
    );
    const remaining = 5 - elapsed;
    return (
        <Button
            primary
            large
            className={'two-factor-ver-submit nui-button-180'}
            onClick={blocking ? null : onClose}
            disabled={blocking || remaining <= 0}
            label={i18n('nui.2fa.login') + (blocking ? '' : ` (${remaining})`)}
        />
    );
}

export default TwoFactorVerSuccess;
